import React, { Component } from 'react'
import {
  MDBBtn,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../../components/content/MDB4Datatable/MDB4Datatable.component'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import WebsiteContentService from '../../shared/services/WebsiteContent.service'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import moment from 'moment'

class WebsiteContentList extends Component {
  state = {
    confirmModal: false,
    viewdata: '',
    contentList: [],
    loading: false,
    deleting: false,
    data: {
      columns: [
        { label: 'Title', field: 'title', sort: 'asc', width: 200 },
        { label: 'Slug', field: 'slug', sort: 'asc', width: 200 },
        { label: 'Page Name', field: 'page_name', sort: 'asc', width: 150 },
        { label: 'Active', field: 'active', sort: 'asc', width: 80 },
        { label: 'Updated', field: 'updated_at', sort: 'asc', width: 120 },
        { label: 'Actions', field: 'actions', sort: 'disabled', width: 120 },
      ],
      rows: [],
    },
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    this.setState({ loading: true })
    try {
      const result = await WebsiteContentService.search()
      this.setState({ contentList: result?.models || [] }, this.setRows)
    } catch (error) {
      toast.error('Failed to load website content.', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } finally {
      this.setState({ loading: false })
    }
  }

  setRows = () => {
    const { contentList } = this.state
    if (!contentList.length) return

    const rows = contentList.map(row => {
      const self = this

      function edit() {
        self.props.history.push(`/admin-website-content/${row.id}/edit`)
      }

      function deleteRow() {
        self.confirmToggle({ viewdata: row })
      }

      const updatedAt = (
        <span searchvalue={row.updated_at ? moment(row.updated_at).format('YYYY/MM/DD') : ''}>
          {row.updated_at ? moment(row.updated_at).format('MM/DD/YYYY') : 'N/A'}
        </span>
      )

      const actions = (
        <div className='d-flex align-items-center justify-content-center'>
          <div className='cursor-pointer d-inline-block mr-3' role='button' onClick={edit}>
            <i className='fa fa-edit fa-2x blue-text p-1'></i>
          </div>
          <div className='cursor-pointer d-inline-block' role='button' onClick={deleteRow}>
            <i className='fa fa-trash fa-2x red-text p-1'></i>
          </div>
        </div>
      )

      return {
        title: row.title || '',
        slug: row.slug || '',
        page_name: row.page_name || '',
        active: row.active ? 'Yes' : 'No',
        updated_at: updatedAt,
        actions,
      }
    })

    this.setState({ data: { ...this.state.data, rows } })
  }

  confirmToggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  deleteContent = async id => {
    this.setState({ deleting: true })
    try {
      await WebsiteContentService.delete(id)
      this.confirmToggle()
      toast.success('Content deleted successfully.', {
        position: toast.POSITION.TOP_RIGHT,
      })
      this.fetchData()
    } catch (error) {
      this.confirmToggle()
      toast.error('Failed to delete content.', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } finally {
      this.setState({ deleting: false })
    }
  }

  render() {
    const { confirmModal, data, loading } = this.state

    const createNew = () => {
      this.props.history.push('/admin-website-content/create')
    }

    return (
      <DashboardLayout>
        <main className='mainSection'>
          <MDBContainer fluid className='mt-5'>
            <h2>
              Website Content
              <div className='d-inline-block'>
                <MDBBtn type='button' color='default' tag='a' floating gradient='blue' onClick={createNew}>
                  <MDBIcon icon='plus' />
                </MDBBtn>
              </div>
            </h2>
            {loading ? (
              <h4 className='p4'>Loading...</h4>
            ) : (
              <div
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '0.4rem',
                  padding: '1rem',
                }}
              >
                <MDB4Datatable
                  data={data}
                  sortRows={['title', 'slug', 'page_name', 'updated_at']}
                  striped
                  bordered
                  small
                  order={['page_name', 'asc']}
                  entriesOptions={[25, 50, 100]}
                  entries={50}
                />
              </div>
            )}

            <MDBModal open={confirmModal} onClose={this.confirmToggle}>
              <MDBModalDialog size='sm'>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Delete Content</MDBModalTitle>
                    <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirmToggle}></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <div className='h5'>
                      Are you sure you want to delete &quot;
                      {this.state.viewdata?.slug}&quot;?
                    </div>
                    <MDBBtn type='button' color='secondary' size='sm' onClick={this.confirmToggle}>
                      Close
                    </MDBBtn>
                    <MDBBtn
                      type='button'
                      color='danger'
                      size='sm'
                      onClick={() => this.deleteContent(this.state.viewdata.id)}
                    >
                      {this.state.deleting ? 'Deleting...' : 'Delete'}
                    </MDBBtn>
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          </MDBContainer>
        </main>
      </DashboardLayout>
    )
  }
}

export default withRouter(WebsiteContentList)
